<template>
  <BasePage title='Tags'>

    <Loader v-if="loading"/>
    <section v-else class="columns">
      <div class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd">
        <section class="flex-space-between align-items-center">
          <h2 class="title is-2 pt-0 mt-0">Tagged Comments <span class="tag" :style="{ 'background-color': '#' + tag.color }">{{ tag.title }}</span></h2>
          <a class="button is-info" @click="download()">Download</a>
        </section>
      
        <section class="d-flex container">

          <ReadOnlyComment v-for="comment in comments"
            :key="comment.id"
            :videoID="comment.video"
            :videoTitle="comment.video_title"
            :userID="userID"
            :elements="comment.elements"
            :id="comment.id"
            :replies="comment.replies"
            :replies_editing="comment.replies_editing"
            :user="comment.user"
            :body="comment.body"
            :created_on="comment.created_on"
            :start_time="comment.start_time"
            :end_time="comment.end_time"
            :tags="comment.tags"
            :scores="comment.scores"
            class="mb-3 mr-2"
            />

        </section>
      </div>
    </section>
  </BasePage>
</template>

<script>
import {
  generalErrorHandler,
} from '../actionTypes'

import { formatTextDate } from '../filters.js'

import axios from 'axios'
import Loader from './Loader'
import BasePage from './BasePage.vue'
import ReadOnlyComment from './ReadOnlyComment.vue'
import store from '../store'

export default {
  name: 'TaggedComments',
  components: {
    BasePage,
    Loader,
    ReadOnlyComment,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      loading: true,
      tag: null,
    }
  },
  filters: {
    formatTextDate,
  },
  async mounted () {
    await this.fetchTag()
    this.loading = false
  },
  computed: {
    userID () {
      return store.state.user.id
    },
    comments () {
      return this.tag.comments
    }
  },
  methods: {
    fetchTag () {
      axios.get(`/api/v1/tags/${this.id}/`,
        { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
      .then(response => {
        this.tag = response.data
      })
      .catch(error => {
        store.dispatch(generalErrorHandler, {
          error,
          message: "Oops, that didn't work."
        })
      })
    },
    download () {
      axios({
        url: `/api/v1/tags/${this.id}/download/`,
        method: 'GET',
        responseType: 'blob', // important
        headers: { 'Authorization': 'Token ' + localStorage.getItem('token') }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'ClassForward Tagged Comments.csv')
        document.body.appendChild(link)
        link.click()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../_variables.scss';

.container {  
  max-width: 700px;
  padding: 25px;
  background-color: #eaeaea;
  flex-direction: column;
}


.tag {
  border-radius: 6px;
  color: whitesmoke;
  font-weight: bold;
  text-shadow: #828282 1px 1px 6px;
}

</style>



// WEBPACK FOOTER //
// TaggedComments.vue?c9bd00da